import React, { ReactNode } from 'react';
import classnames from 'classnames';

import { FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import OutlinedTextField, { OutlinedTextFieldProps } from '@material-ui/core/TextField';

const textFieldClasses = makeStyles(theme => ({
  marginDefault: {
    marginBottom: theme.spacing(2.5)
  },
  marginDense: {
    marginBottom: theme.spacing(1)
  },
  marginNone: {
    marginBottom: 0
  },
  disableShadow: {
    '& .MuiInputBase-root': {
      '&.Mui-focused': {
        boxShadow: 'none'
      }
    }
  },
  label: {
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: theme.typography.fontSizeRoot,
    marginBottom: theme.spacing(1)
  },
  helperText: {
    position: 'absolute',
    bottom: theme.spacing(2.5) * -1
  }
}));

export interface TextFieldProps extends Omit<OutlinedTextFieldProps, 'variant' | 'margin'> {
  [others: string]: any,
  label?: string | ReactNode | undefined,
  disableShadow?: boolean,
  margin?: 'default' | 'dense' | 'none' | undefined
}

export default function TextField ({
  label,
  disableShadow = false,
  margin = 'default',
  ...others
}: TextFieldProps) {
  const classes = textFieldClasses();
  return (
    <FormControl className={classnames({
      [classes.marginDefault]: margin === 'default',
      [classes.marginNone]: margin === 'none',
      [classes.marginDense]: margin === 'dense'
    })}
    >
      {
        label && (
          <label htmlFor={others.id} className={classes.label}>
            {label}
          </label>
        )
      }
      <OutlinedTextField
        {...others}
        classes={{
          root: classnames({
            [classes.disableShadow]: disableShadow
          })
        }}
        variant='outlined'
        FormHelperTextProps={{ className: classes.helperText }}
      />
    </FormControl>
  );
}
